import * as React from "react"
import {useEffect} from "react"
import {useSearchParams} from "react-router-dom";
import {batch} from "@preact/signals-react"
import {Grid} from "@mui/material"

import {HOME_ROUTES, MARKETPLACES_ROUTES} from "@constants"
import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy, seller} from "@signals";
import PageWrapper from "Pages/@PageWrapper"
import { TourProvider, TourTarget } from "@tour"
import {useMarketplacesSellerDetailsSearch} from "./@hooks"
import {isSellerDetailsProductKpi, isSellerDetailsEmpty, resetMarketplacesSellerDetails} from "./@signals"
import MarketplacesProductDetailsEvolution from "./Evolution"
import MarketPlacesProductDetailsEvolutionTable from "./EvolutionDetails"
import MarketplacesSellerDetailsFilters from "./Filters"
import MarketPlacesSellerDetailsTable from "./SellerTable"
import MarketPlacesProductDetailsTable from "./ProductTable"



export default function MarketplacesSellerDetailsPage() {
    const { handleSubmit } = useMarketplacesSellerDetailsSearch()
    const [searchParams] = useSearchParams()

    const launch = searchParams.get('launch')

    useEffect(() => {
        if (launch === 'true') batch(() => {
            isLoadingCommonFilters.value = true
            handleSubmit(commonFiltersValue.value)
        })
    }, [])
    
    useEffect(() => {
        return () => resetMarketplacesSellerDetails()
    }, [])

    return <PageWrapper
        head={`DIP Insight | ${MARKETPLACES_ROUTES.TITLE}`}
        title={MARKETPLACES_ROUTES.TITLE}
        subtitle={MARKETPLACES_ROUTES.SELLER_DETAILS_SUBTITLE}
        isEmpty={isSellerDetailsEmpty.value}
        filters={<MarketplacesSellerDetailsFilters />}
        hasErrors={isSystemBusy.value}
        tourPageKey="sellerDetails"
    >
        <Grid container spacing={4} sx={{ mt: 1 }}>
            { !isSellerDetailsProductKpi.value && <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="seller-details-table" height={350} />
                <MarketPlacesSellerDetailsTable />
            </Grid> }

            { !!isSellerDetailsProductKpi.value && <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="seller-details-table" height={350} />
                <MarketPlacesProductDetailsTable />
            </Grid> }

            { !!isSellerDetailsProductKpi.value && <Grid item xs={12}>
                <MarketplacesProductDetailsEvolution />
            </Grid> }

            { !!isSellerDetailsProductKpi.value && <Grid item xs={12}>
                <MarketPlacesProductDetailsEvolutionTable />
            </Grid> }
        </Grid>
    </PageWrapper>
}